import React from 'react'
import createReactClass from 'create-react-class'
import ModalWrapper from './modal-wrapper'
import ModalContent from './modal-content'
import './modal-content.scss'

export default createReactClass({
  render () {
    return (
      <ModalWrapper>
        <ModalContent {...this.props}>
          {this.props.error ? <div className='modal-error'>{this.props.error}</div> : ''}
          <form className='show-extra-text'>
            <div>
              <p htmlFor='text' style={{maxHeight: '350px', overflowY: 'auto'}}>{this.props.text}</p>
            </div>
          </form>
        </ModalContent>
      </ModalWrapper>
    )
  },
})



// WEBPACK FOOTER //
// ./src/components/modal-panels/show-cell-text-modal-panel.js